<template>
    <footer class="footer">
        <div class="footer-primary">
            <div class="footer-primary__contents">
                <div class="footer-primary__col">
                    <ul class="footer-primary__link">
                        <li v-for="link in links" :key="link.text" class="footer-primary__link-list">
                            <a class="btn" :href="link.href" target="_blank">{{ link.text }}</a>
                        </li>
                    </ul>
                    <ul class="footer-primary__contact">
                        <li>주소(본회) : 03294 서울특별시 마포구 월드컵북로 54길 11 (상암동, 전자회관) 11~12층</li>
                        <li class="clear">주소(센터) : 04366 서울특별시 용산구 청파로 77, 원효상가 6동 3층 KEA 전자제조센터</li>
                        <li class="clear">TEL : 02-6388-6000</li>
                        <li>FAX : 02-6388-6009</li>
                        <li>사업자등록번호 : 220-82-00143</li>
                    </ul>
                    <p class="copyright">Copyright 2021. KOREA ELECTRONICS ASSOCIATION. All rights reserved.</p>
                </div>
                <div class="footer-primary__col">
                    <ul class="footer-primary__sns">
                        <li><a href="#"><img src="/images/icon/icon-y.png" alt="유튜브"></a></li>
                        <li><a href="#"><img src="/images/icon/icon-f.png" alt="페이스북"></a></li>
                        <li><a href="#"><img src="/images/icon/icon-t.png" alt="트위터"></a></li>
                    </ul>
                </div>
            </div>
        </div>

        <!-- <div class="quick-menu">
            <v-btn depressed rounded href="/mypage/question" color="primary">
                <span>관리자 문의</span>
                <img src="/images/icon/contact.png" alt="">
            </v-btn>
        </div> -->
    </footer>
</template>

<script>
export default {
    data(){
        return {
            links:[
                { text: '개인정보보호정책', href: '#' },
                { text: '회원사서비스현장', href: '#' },
                { text: '국내관련기관', href: '#' },
            ]
        }
    },
    mounted(){
    },
    methods: {
    }
}
</script>